import React, { Component } from 'react'
import Table from '@common/Table'
import getColumns from './column'
import style from '../style.module.less'
import { observer } from 'mobx-react'
import { JIAMENG_CUSTOMER_DETAIL_PATH_A } from '@constant'

@observer
export default class extends Component {
  onRowClick = record => {
    window.open(`${JIAMENG_CUSTOMER_DETAIL_PATH_A}/${record.id}`)
  }

  render() {
    const { store } = this.props

    return (
      <div className={style['table-wrap']}>
        <Table
          columns={getColumns(store)}
          store={store}
          shouldGetListWhenDidMount={false}
          onRow={record => {
            return {
              onClick: () => this.onRowClick(record)
            }
          }}
        />
      </div>
    )
  }
}
